import { configureStore } from "@reduxjs/toolkit";
import { toastSlice } from "./slices/toast.slice";
import { centerModalSlice } from "./slices/CenterModal.slice.js";
import { sidebardrawerSlice } from "./slices/SidebarDrawer.slice.js";
import { secondCenterModalSlice } from "./slices/SecondCenterModal.slice.js";
import { authSlice } from "./slices/session/auth";
import { profileSlice } from "./slices/profile";
import { foldersSlice } from "./slices/folders";
import { filesSlice } from "./slices/files";
import { trashSlice } from "./slices/trash";
import { generalSlice } from "./slices/general";

function configStore() {
  const store = configureStore({
    reducer: {
      toast: toastSlice.reducer,
      centerModal: centerModalSlice.reducer,
      sidebar: sidebardrawerSlice.reducer,
      secondCenterModal: secondCenterModalSlice.reducer,
      auth: authSlice.reducer,
      profile: profileSlice.reducer,
      folders: foldersSlice.reducer,
      files: filesSlice.reducer,
      trash: trashSlice.reducer,
      general: generalSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }),
  });
  return store;
}

export default configStore;
